import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { fg } from '@atlaskit/platform-feature-flags';
import { messages } from '../../../../messages';
import { EmptyState } from '../../components/EmptyState';
import { SpotSearchNoResult } from '../errored/error-svg/search-no-result';
import { UnavailableSVG } from './unavailable-svg';
var RelatedLinksUnavailableView = function RelatedLinksUnavailableView() {
  var intl = useIntl();
  return fg('platform-linking-visual-refresh-v2') ? /*#__PURE__*/React.createElement(EmptyState, {
    renderImage: function renderImage() {
      return /*#__PURE__*/React.createElement(SpotSearchNoResult, null);
    },
    header: intl.formatMessage(messages.related_links_modal_unavailable_title),
    description: /*#__PURE__*/React.createElement(FormattedMessage, messages.related_links_modal_unavailable_description)
  }) : /*#__PURE__*/React.createElement(EmptyState, {
    renderImage: function renderImage() {
      return /*#__PURE__*/React.createElement(UnavailableSVG, null);
    },
    header: intl.formatMessage(messages.related_links_modal_unavailable_header),
    description: /*#__PURE__*/React.createElement(FormattedMessage, messages.related_links_modal_unavailable_message)
  });
};
export default RelatedLinksUnavailableView;